import classNames from 'classnames/bind';
import React from 'react';
import { RiToolsLine } from 'react-icons/ri';
import { v4 as uuidv4 } from 'uuid';

import Copter from './common/Copter';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const Panel = ({ data: [robot] }) => {
  switch (robot.metadata['INSPECTION_MODEL_KEY']) {
    case 'common/Copter':
      return <Copter data={[robot]} />;

    default:
      return (
        <div className={cx('container')}>
          <div className={cx('wrapper')}>
            Inspection is not available for this vehicle.
            <br />
            Please contact us for assistance.
          </div>
        </div>
      );
  }
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Inspection';
Command.displayMode = 'overlay';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiToolsLine;
Command.Panel = Panel;

export default Command;
